require("-!/builds/gokilat/kilat-ecomm-automation/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!less-loader!/builds/gokilat/kilat-ecomm-automation/node_modules/font-awesome-webpack/font-awesome-styles.loader.js!/builds/gokilat/kilat-ecomm-automation/src/theme/font-awesome.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-webpack/index.loader.js!./src/theme/font-awesome.config.prod.js
// module id = 675
// module chunks = 0